module.exports = __webpack_public_path__ + "media/images/undraw_eating_together_re_ux62-20df7628cee054b0fcbff15d1bea998b.svg";